// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"922b31d4","563":"4a3bd22a","790":"987ab0d9","844":"28446869"}[chunkId] + ".chunk.js";
};